import { useCallback, useState, useEffect, useContext } from "react";
import style from '../../../styles/mystyle.module.css'
import config from '../../../next.config.js'
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { Navbar } from '../Layout/Navbar'
import SiteSeo from "../seo/SiteSeo";
import dynamic from "next/dynamic";
import {useQuery} from '@tanstack/react-query'
import LoadingBackground from "../Book/LoadingBackground";
const Background = dynamic(() => import("../Book/Background"),{loading: () =><LoadingBackground/>})
const NumberPhone = dynamic(() => import('../Book/NumberPhone'))
const Reviews = dynamic(() => import('./Reviews'))
const SizeSilderCard = dynamic(() => import('./SizeSilderCard'))
const TabsMedical = dynamic(() => import('./Tabs'))
import { getTermsByVocabCodes } from "../../helpers/global/term/term";
function White({dehydratedState,entityWorkDays, entityId, pid, entityDetails, majors, address, blog, StatusIds, days, blogTypes ,htmlTexts}) {
  const router = useRouter();
  const { t } = useTranslation("common");
  const [showClinics, setShowClinics] = useState(false)
  const [showDepartments, setShowDepartments] = useState(false)
  const [Images, setImages] = useState([]);
  const callbackImage = useCallback(callback => {
    setImages(callback);
  }, []);

  let AddressDetailsForSeoString = "";
  // let appTerms=dehydratedState.queries.filter(ele=>ele.queryKey.includes("app-terms"))[0].state.data
  useEffect(() => {

    if (pid[0] == "hospital" || pid[0] == "medical-center") {
      setShowDepartments(true)
    }
    if (pid[0] == "hospital-department" || pid[0] == "medical-center-department") {
      setShowClinics(true)
    }
  }, [pid, entityId])
  let fullMajorsforseo = " "
  let tempData = JSON.parse(majors)
  if (entityId) {
    tempData = tempData.sort((a, b) => (b.priority - a.priority))
    tempData = tempData.map(majorItem => {
      majorItem["titles"] = majorItem["titles"].filter(title => title.language.code == router.locale)
      majorItem["major"] = majorItem["major"].filter(major => major.language.code == router.locale)
      majorItem["subMajor"] = majorItem["subMajor"].filter(subMajor => subMajor.language.code == router.locale)
      return majorItem
    })
    let tempTitleListIds = Array.from(new Set(tempData.map(item => item.titleId)))
    for (let i = 0; i < tempTitleListIds.length; i++) {
      fullMajorsforseo += "("
      if(tempData.filter(item => item.titleId == tempTitleListIds[i])[0].titles.length>0){
        fullMajorsforseo += tempData.filter(item => item.titleId == tempTitleListIds[i])[0].titles[0].name.toString() + " "
      }
      let tempMajorListIds = tempData.filter(item => item.titleId == tempTitleListIds[i]).map(item =>item.major.length>0&& item.major[0].id)
      tempMajorListIds = Array.from(new Set(tempMajorListIds))
      for (let j = 0; j < tempMajorListIds.length; j++) {
        fullMajorsforseo += tempData.find(item => item.titleId == tempTitleListIds[i] && item.major.length>0&&item.major[0].id == tempMajorListIds[j])?tempData.find(item => item.titleId == tempTitleListIds[i] && item.major.length>0&&item.major[0].id == tempMajorListIds[j]).major[0].name.toString():"" + " "
        let tempSubMjrList = tempData.filter(item => item.titleId == tempTitleListIds[i] && item.major.length>0&& item.major[0].id == tempMajorListIds[j]).map(item => item.subMajorId)
        tempSubMjrList = Array.from(new Set(tempSubMjrList))
        fullMajorsforseo += t("specialist") + "  ("
        for (let k = 0; k < tempSubMjrList.length; k++) {
          tempData.filter(item => item.titleId == tempTitleListIds[i] &&  item.major.length>0&&item.major[0].id == tempMajorListIds[j] && item.subMajorId == tempSubMjrList[k]).forEach(item => {
            fullMajorsforseo += item.subMajor[0].name.toString()
            tempSubMjrList.length > 1 && k != tempSubMjrList.length - 1 ? fullMajorsforseo += "-" : ""
          })
        }
        fullMajorsforseo += " )"
      }
    }
  }
  let officialName=JSON.parse(entityDetails)[0].transEntityDetails.filter(ele=>ele.language.length>0&&ele.language[0].code==router.locale)
if(officialName.length>0){
  officialName=officialName[0].officialName
}
else{
  officialName=JSON.parse(entityDetails)[0].transEntityDetails.length>0&&JSON.parse(entityDetails)[0].transEntityDetails[0].officialName
}
const [exchangeCurrenciesRes,setExchangeCurrenciesRes]=useState([])
const [currencies,setCurrencies]=useState([])
// const [productCategories,setProductCategories]=useState([])
const info=useQuery({queryKey:["product-categories"],queryFn:async()=>JSON.parse(await getTermsByVocabCodes(["product-categories"]))})

useEffect(()=>{
  // getTermsByVocabCodes(["product-categories"]).then(termRes=>{
  //   setProductCategories(JSON.parse(termRes))
  // }).catch(err=>console.log(err))
},[])
  return (
    <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>
      {/* {console.log("days=========>",days)} */}
      <>{JSON.parse(entityDetails).length > 0 && <SiteSeo
        title={
          JSON.parse(entityDetails).length > 0
            ? officialName
            : ""
        }
        meta={[{
          name: "description",
          title: officialName,
          url: config.env.baseUrl + router.asPath,
          image:
          Images.length > 0 && Images[0].image != null
          ? Images[0].image
          : config.basePath + "/assest/logo.svg",
          content:
            t("MadicalSearchPageMetaDescription") + " " +
            officialName
            + "-" +
            t("MadicalSearchPageMetaDescription2") +
            fullMajorsforseo +
            "-" +
            AddressDetailsForSeoString

        }]}
      />
      }
      </>
   
      <Navbar showDownloadAppSection={false} redirectToHome={true} >
        <Background
          entityId={entityId}
          pid={pid}
          lstStatus={StatusIds}
          callbackImage={callbackImage}
          entityDetails={JSON.parse(entityDetails)}
          majors={majors}
        />
        <Reviews entityId={entityId} pid={pid} lstStatus={StatusIds} entityDetails={JSON.parse(entityDetails)} />
        <NumberPhone ShowDetails={false} entityDetails={JSON.parse(entityDetails)} />
        <SizeSilderCard entityId={entityId} pid={pid} entityDetails={JSON.parse(entityDetails)} statusLst={StatusIds} days={days} workTimes={[{entityWorkDays:JSON.parse(entityWorkDays)}]} />
        <TabsMedical
          infoTab={'1'}
          entityId={entityId} 
          pid={pid}
          majors={majors}
          address={address}
          blog={blog}
          StatusIds={StatusIds}
          days={days}
          productCategories={info.data}
          blogTypes={blogTypes}
          showDepartments={showDepartments}
          showClinics={showClinics}
          entityDetailsData={JSON.parse(entityDetails)}
          workTimes={[{entityWorkDays:JSON.parse(entityWorkDays)}]}
          currencies={currencies}
          exchangeCurrenciesRes={exchangeCurrenciesRes}
        />
      </Navbar>
    </div>
  )
}

export default White